import React, { useEffect, useState } from "react";
import { useGetSubServiceOnIdBasisDataQuery } from "../../../Services/vehicle/Vehicle";
import "./SubServiceModal.scss";
import { useNavigate } from "react-router-dom"; // ADD THIS

interface IPROPS {
  activeServiceId: any;
  setIsCartOpen: any;
  setCurrentStep: any;
  setIsSubServiceModalOpen: any;
  vehicleData: any;
  token: any;
  setOpenVehicleModal: any;
  setOpenModal: any;
}

const SubServiceModal: React.FC<IPROPS> = ({
  activeServiceId,
  setIsCartOpen,
  setCurrentStep,
  setIsSubServiceModalOpen,
  vehicleData,
  token,
  setOpenVehicleModal,
  setOpenModal,
}) => {
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [subServiceData, setSubServiceData] = useState([]);
  const { data: subService } =
    useGetSubServiceOnIdBasisDataQuery(activeServiceId);

  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    if (subService) {
      setSubServiceData(subService);
    }
  }, [subService]);

  useEffect(() => {
    const storedCart = sessionStorage.getItem("cartItems");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  const isSubServiceInCart = (subServiceId: any) => {
    return cartItems?.some((item) => item?.sub_service?.id === subServiceId);
  };

  // Update: Navigation after cart open
  const bookHandler = () => {
    setIsSubServiceModalOpen(false);

    if (!token) {
      setOpenModal("login");
      return;
    }

    if (token && vehicleData.length === 0) {
      setOpenVehicleModal(true);
      return;
    }

    setCurrentStep(1);
    setIsCartOpen(true);
    navigate("/vehicle/select"); // Add navigation after opening cart
  };

  return (
    <div className="sub-service-modal-container">
      <div className="sub-service-content">
        {subServiceData?.map((sub_service, index) => (
          <div className="sub-service-card" key={index}>
            <div className="sub-service-info">
              <div className="sub-service-name">
                <p>
                  <span>{sub_service?.name}</span>
                </p>
              </div>
            </div>
            <div className="sub-service-action">
              <button
                className={`book-now-btn ${
                  isSubServiceInCart(sub_service?.id) ? "disabled" : ""
                }`}
                onClick={bookHandler}
                disabled={isSubServiceInCart(sub_service.id)}
              >
                <span>Book now</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubServiceModal;
